import _get from 'lodash.get'

import { createReducer, updateState } from 'redux_new/handlers'
import { conversationPassengersTypes, conversationsTypes } from 'redux_new/conversations/types'

const initialPassengers = {
  isOpen: false,
  isLoading: false,
  passengers: [],
}

const initialState = {
  initial: { ...initialPassengers },
  // [USER.id]: initialPassengers
}

/**
 * Display or not passengers info
 * @param {Object} action
 * @param {string} action.userId
 * @param {boolean} action.isOpen
 * @param {boolean} [action.isLoading=false]
 */
const conversationPassengerDisplay = (state, action) => {
  const { isOpen, userId, isLoading = false } = action

  return updateState(state, {
    [userId]: {
      ...(state[userId] || initialPassengers),
      isOpen,
      isLoading,
    },
  })
}

/**
 * Update passengers
 * @param {Object} action
 * @param {string} action.userId
 * @param {Array} action.passengers
 */
const conversationPassengersUpdate = (state, action) => {
  const { userId, passengers } = action

  const userPassengers = passengers.length > 0 ? passengers : _get(state, `${userId}.passengers`, initialPassengers.passengers)

  return updateState(state, {
    [userId]: {
      ...(state[userId] || initialPassengers),
      isLoading: false,
      passengers: [].concat(userPassengers),
    },
  })
}

/**
 * Remove user from conversationPassengers
 * @param {Object} action
 * @param {string} action.userId
 */
const conversationsRemoveOne = (state, action) => {
  const { userId } = action

  delete state[userId]

  return updateState(state)
}

export default createReducer(initialState, {
  [conversationPassengersTypes.display]: conversationPassengerDisplay,
  [conversationPassengersTypes.update]: conversationPassengersUpdate,
  [conversationsTypes.removeOne]: conversationsRemoveOne,
  [conversationsTypes.removeAll]: () => updateState(initialState),
})

// import {
//     GETTING_USER_PASSENGERS,
//     SET_USER_PASSENGERS,
//     SET_USER_PASSENGERS_ERRORS
//   } from '../../../types/conversations/plugins';

//   const initialPluginsPassengers = {
//     gettingPassengers: false,
//     errors: {},
//     passengers: []
//   };

//   export default function passengers(state = initialPluginsPassengers, action) {
//     switch (action.type) {
//       case GETTING_USER_PASSENGERS: {
//         const { gettingPassengers } = action;
//         return Object.assign({}, state, { gettingPassengers });
//       }
//       case SET_USER_PASSENGERS: {
//         const { passengers } = action;
//         return Object.assign({}, state, { passengers });
//       }
//       case SET_USER_PASSENGERS_ERRORS: {
//         const { errors } = action;
//         return Object.assign({}, state, { errors });
//       }
//       default: {
//         return state
//       }
//     }
//   }
